import { render } from "./App.vue?vue&type=template&id=a1aa0da4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a1aa0da4&lang=css"

import exportComponent from "C:\\Users\\moritz.kretschmer\\Documents\\hiddenstorm\\hiddenstorm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__